import React, { useState, useEffect } from 'react';
import { 
  LayoutDashboard, CalendarCheck, Home, Users, FolderKanban, CheckSquare, Package, 
  BarChart3, Search, Bell, Settings, Menu, 
  Plus, Edit, Trash2, Eye, Download, Share2,
  AlertCircle, CreditCard, KeyRound, FileText, IdCard,
   MoreVertical, User, LogOut, Bike, UserCircle, Briefcase, ToggleRight,
   BookCheck, IdCardLanyard, Users2,  ChevronDown, FileType,
  List, Layers, PersonStanding, FileTypeIcon, FileUser,
  MapPinned, Building2, Landmark, 
} from 'lucide-react';
import '../css/Dashboard.css';
import Overview from './Overview';
import Members from './Members';
import TRB from './TRB';
import Dealers from './Dealers';
import Contacts from './Contacts';
import Bookings from './Bookings';
import Careerposting from './Careerposting';
import Applications from './Applications';
import Priceforms from './Priceforms';
import Institutional from './Institutional';
import Diplosmaxplus from './Diplosmaxplus';
import SEOSchema from './SEOSchema';
import HeroBanner from './HeroBanner';
import Vehicles from './Vehicles';
import Payments from './Payments';
import SectionManager from './SectionManager';
import PageEditor from './PageEditor';
import AuditLogs from './AuditLogs';
import Cities from './Cities';
import DealersList from './DealersList';
import ApiKeys from './APIKeys';
import Banks from './Banks';
import Blogs from './Blogs1';
import NotificationBell from './NotificationBell';
//import Modal from './Modal';
import { useNavigate } from 'react-router-dom';

const notifications = [
  {
    module: "contacts",
    title: "Contact Forms",
    count: 3,
  },
  {
    module: "booking",
    title: "Bookings",
    count: 2,
  },
  {
    module: "payments",
    title: "Payments",
    count: 1,
    description: "₹84,999 Payment Received",
  },
  {
    module: "applications",
    title: "Career Applications",
    count: 5,
  },
  {
    module: "dealers",
    title: "Dealer Enquiries",
    count: 1,
    description: "ABC Motors, Bangalore",
  },
];

const NAV_SECTIONS = [
  {
    title: 'Overview',
    items: [
      { key: 'overview', label: 'Dashboard', icon: LayoutDashboard },
    ],
  },
  {
    title: 'Sales',
    items: [
      { key: 'tasks', label: 'Test Ride Bookings', icon: CalendarCheck, badge: 6 },
      { key: 'dealers', label: 'Dealer Forms', icon: FileText },
      { key: 'contacts', label: 'Contact Forms', icon: IdCard },
      { key: 'bookings', label: 'Bookings', icon: BookCheck },
      { key: 'payments', label: 'Payments', icon: CreditCard },
    ],
  },
  {
    title: 'Customers',
    items: [
      { key: 'members', label: 'Members', icon: Users },
      { key: 'applications', label: 'Applications', icon: UserCircle },
      { key: 'careers', label: 'Career Postings', icon: Briefcase },
    ],
  },
  {
    title: 'Website',
    items: [
      { key: 'pageeditor', label: 'Page Editor', icon: FileType },
      { key: 'blogs', label: 'Blogs', icon: List },
      { key: 'seoschema', label: 'SEO Schema', icon: Search },
    ],
  },
  {
    title: 'Inventory',
    items: [
      { key: 'vehicles', label: 'Vehicles', icon: Bike },
      { key: 'dealerslist', label: 'Dealers', icon: Building2 },
      { key: 'cities', label: 'Cities & States', icon: MapPinned },
      { key: 'banks', label: 'Banks', icon: Landmark },
    ],
  },
  {
    title: 'System',
    items: [
      { key: 'apiaccess', label: 'API Keys', icon: KeyRound },
      { key: 'auditlogs', label: 'Audit Logs', icon: FileUser },
      { key: 'sectionmanager', label: 'Section Visibility', icon: ToggleRight },
    ],
  },
];

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [profileopen, setProfileOpen] = useState(false);
  const [adminData, setAdminData] = useState(null);

  const [formsOpen, setFormsOpen] = useState(false); //forms grouping together

  const [allowedTabs, setAllowedTabs] = useState([]); //tabs access

  const [openNotifications, setOpenNotifications] = useState(false);

  const navigate = useNavigate();

  const generateAvatar = (fname) => {
    if(!fname) return '';
    const parts = fname.trim().split(' ');
    const initials = parts.length>=2 ? parts[0][0] + parts[1][0] : parts[0][0];
    return initials.toUpperCase();
  } 

  useEffect(() => {
    const savedUser = JSON.parse(localStorage.getItem('login'));
    if (savedUser) {
      const avatar = generateAvatar(savedUser.name);
      const updated = {...savedUser, avatar};
      setAdminData(updated);
       setAllowedTabs(savedUser.tabs || []);
       // (Optional) update in localStorage too, so it persists
    localStorage.setItem('login', JSON.stringify(updated));
    }
  }, []);

  useEffect(() => { 
  if (allowedTabs.length === 0) return;

  if (!allowedTabs.includes(activeTab)) {
    setActiveTab(allowedTabs[0]);
  }
}, [allowedTabs]);

  const hasAccess = (tab) => {
     //  SUPER ADMIN BYPASS
  if (adminData?.role === 'superadmin') return true;

  return allowedTabs.includes(tab);
};

 

 



  const projectFormData = [
    { id: 1, project: 'Website Redesign', client: 'Tech Corp', status: 'In Progress', progress: 75, deadline: '2024-11-30', priority: 'High' },
    { id: 2, project: 'Mobile App Dev', client: 'StartupXYZ', status: 'In Progress', progress: 45, deadline: '2024-12-15', priority: 'Medium' },
    { id: 3, project: 'CRM Integration', client: 'Enterprise Ltd', status: 'Review', progress: 90, deadline: '2024-11-10', priority: 'Critical' },
    { id: 4, project: 'Marketing Campaign', client: 'Brand Co', status: 'Planning', progress: 30, deadline: '2024-12-01', priority: 'Low' },
    { id: 5, project: 'Database Migration', client: 'DataCorp', status: 'In Progress', progress: 60, deadline: '2024-11-20', priority: 'High' },
  ];

 

  const inventoryFormData = [
    { id: 1, item: 'Laptop - Dell XPS 15', quantity: 24, category: 'Electronics', price: '$1,299', lastUpdated: '2024-10-25' },
    { id: 2, item: 'Office Chair - Ergonomic', quantity: 15, category: 'Furniture', price: '$399', lastUpdated: '2024-10-20' },
    { id: 3, item: 'Monitor - 27" 4K', quantity: 8, category: 'Electronics', price: '$549', lastUpdated: '2024-10-28' },
    { id: 4, item: 'Desk - Standing', quantity: 12, category: 'Furniture', price: '$799', lastUpdated: '2024-10-22' },
    { id: 5, item: 'Wireless Mouse', quantity: 45, category: 'Accessories', price: '$49', lastUpdated: '2024-10-26' },
  ];

  const reportsFormData = [
    { id: 1, report: 'Q3 Financial Report', type: 'Financial', generatedBy: 'Finance Team', date: '2024-10-01', size: '2.4 MB' },
    { id: 2, report: 'Customer Satisfaction', type: 'Survey', generatedBy: 'Marketing', date: '2024-10-15', size: '1.8 MB' },
    { id: 3, report: 'Performance Analytics', type: 'Analytics', generatedBy: 'Data Team', date: '2024-10-20', size: '3.2 MB' },
    { id: 4, report: 'Security Audit', type: 'Security', generatedBy: 'IT Security', date: '2024-10-18', size: '1.5 MB' },
    { id: 5, report: 'Monthly Operations', type: 'Operations', generatedBy: 'Operations', date: '2024-10-22', size: '2.1 MB' },
  ];

  const renderContent = () => {
    if (!hasAccess(activeTab)) {
  return <div>🚫 Access Denied</div>;
}
    switch(activeTab) {
      case 'overview':
        return (
          <>
          <Overview />
          </>
       
        );
      
      case 'members':
        return (
          <>
          <Members />
          </>
         
        );
      
      case 'projects':
        return (
          <div className="table-content">
            <div className="content-header">
              <div>
                <h2>Project Overview</h2>
                <p>Track and manage all your projects</p>
              </div>
              <div className="header-actions">
                <button className="secondary-btn">
                  <Download size={18} />
                  Export
                </button>
                <button className="primary-btn">
                  <Plus size={18} />
                  New Project
                </button>
              </div>
            </div>
            <div className="table-container">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Project Name</th>
                    <th>Client</th>
                    <th>Status</th>
                    <th>Progress</th>
                    <th>Priority</th>
                    <th>Deadline</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {projectFormData.map(project => (
                    <tr key={project.id}>
                      <td><strong>{project.project}</strong></td>
                      <td>{project.client}</td>
                      <td><span className={`status-badge ${project.status.toLowerCase().replace(' ', '-')}`}>{project.status}</span></td>
                      <td>
                        <div className="progress-container">
                          <div className="progress-bar">
                            <div className="progress-fill" style={{width: `${project.progress}%`}}></div>
                          </div>
                          <span className="progress-text">{project.progress}%</span>
                        </div>
                      </td>
                      <td><span className={`priority-badge ${project.priority.toLowerCase()}`}>{project.priority}</span></td>
                      <td>{project.deadline}</td>
                      <td>
                        <div className="action-buttons">
                          <button className="icon-action-btn" title="Edit">
                            <Edit size={16} />
                          </button>
                          <button className="icon-action-btn" title="View">
                            <Eye size={16} />
                          </button>
                          <button className="icon-action-btn" title="More">
                            <MoreVertical size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      
      case 'tasks':
        return (
            <>
            <TRB />
            </>
      
        );
      
      case 'inventory':
        return (
          <div className="table-content">
            <div className="content-header">
              <div>
                <h2>Inventory Management</h2>
                <p>Monitor stock levels and manage inventory</p>
              </div>
              <div className="header-actions">
                <button className="secondary-btn">
                  <Download size={18} />
                  Export
                </button>
                <button className="primary-btn">
                  <Plus size={18} />
                  Add Item
                </button>
              </div>
            </div>
            <div className="table-container">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Category</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Last Updated</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {inventoryFormData.map(item => (
                    <tr key={item.id}>
                      <td><strong>{item.item}</strong></td>
                      <td><span className="category-badge">{item.category}</span></td>
                      <td>
                        <span className={`quantity-badge ${item.quantity < 10 ? 'low' : item.quantity > 30 ? 'high' : 'medium'}`}>
                          {item.quantity < 10 && <AlertCircle size={14} />}
                          {item.quantity} units
                        </span>
                      </td>
                      <td><strong>{item.price}</strong></td>
                      <td>{item.lastUpdated}</td>
                      <td>
                        <div className="action-buttons">
                          <button className="icon-action-btn" title="Edit">
                            <Edit size={16} />
                          </button>
                          <button className="icon-action-btn" title="Restock">
                            <Package size={16} />
                          </button>
                          <button className="icon-action-btn danger" title="Delete">
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );

      case 'dealers':
        return (
            <>
              <Dealers />
            </>
        );

      case 'contacts':
        return (
            <>
              <Contacts />
            </>
        );
      
      case 'bookings':
        return (
         <>
         <Bookings />
         </>
        );

      case 'careers':
        return (
            <>
              <Careerposting />
            </>
        );

      case 'applications':
        return (
          <>
            <Applications />
          </>
        );

      case 'priceforms':
        return (
          <>
            <Priceforms />
          </>
        );

      case 'apiaccess':
        return (
          <>
          <ApiKeys />
          </>
        )

       case 'diplosmaxplus':
        return (
          <>
            <Diplosmaxplus />
          </>
        );

       case 'institutionalsales':
        return (
          <>
            <Institutional />
          </>
        );

        case 'seoschema':
        return (
          <>
            <SEOSchema />
          </>
        );

        case 'blogs':
          return (
            <>
            <Blogs />
            </>
          )

         case 'herobanner':
        return (
          <>
            <HeroBanner />
          </>
        );

        case 'vehicles':
        return (
          <>
            <Vehicles />
          </>
        );

          case 'banks':
        return (
          <>
            <Banks />
          </>
        );

        case 'payments':
          return (
            <>
            <Payments />
            </>
          )

        case 'sectionmanager':
          return (
            <>
            <SectionManager />
            </>
          )

        case 'pageeditor':
          return (
            <>
            <PageEditor />
            </>
          )
        case 'auditlogs':
          return (
            <>
            <AuditLogs />
            </>
          )

        case 'cities':
  return (
    <>
      <Cities />
    </>
  );

case 'dealerslist':
  return (
    <>
      <DealersList />
    </>
  );
      
      case 'reports':
        return (
          <div className="table-content">
            <div className="content-header">
              <div>
                <h2>Reports & Analytics</h2>
                <p>View and generate comprehensive reports</p>
              </div>
              <div className="header-actions">
                <button className="secondary-btn">
                  <Download size={18} />
                  Export All
                </button>
                <button className="primary-btn">
                  <Plus size={18} />
                  Generate Report
                </button>
              </div>
            </div>
            <div className="table-container">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Report Name</th>
                    <th>Type</th>
                    <th>Generated By</th>
                    <th>Date</th>
                    <th>Size</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {reportsFormData.map(report => (
                    <tr key={report.id}>
                      <td><strong>{report.report}</strong></td>
                      <td><span className="type-badge">{report.type}</span></td>
                      <td>{report.generatedBy}</td>
                      <td>{report.date}</td>
                      <td>{report.size}</td>
                      <td>
                        <div className="action-buttons">
                          <button className="icon-action-btn" title="Download">
                            <Download size={16} />
                          </button>
                          <button className="icon-action-btn" title="Share">
                            <Share2 size={16} />
                          </button>
                          <button className="icon-action-btn" title="View">
                            <Eye size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    
    <div className="dashboard">
      {/* Sidebar */}
      <aside className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="logo-container">
            <div className="logo-icon">
            
              <img 
    src="/numeros.ico" 
    alt="Numeros Logo" 
    width={20} 
    height={20} 
  />
            </div>
            {isSidebarOpen && (
              <div className="logo-text-group">
                <h2 className="logo">Numeros</h2>
                <p className="logo-subtitle">Admin Panel</p>
              </div>
            )}
          </div>
        </div>

           <nav className="sidebar-nav">
          {NAV_SECTIONS.map((section) => {
            const visibleItems = section.items.filter((item) => hasAccess(item.key));
            if (visibleItems.length === 0) return null;
 
            return (
              <div className="nav-section" key={section.title}>
                {isSidebarOpen && (
                  <p className="nav-section-title">{section.title}</p>
                )}
                {visibleItems.map((item) => {
                  const Icon = item.icon;
                  return (
                    <button
                      key={item.key}
                      className={`nav-item ${activeTab === item.key ? 'active' : ''}`}
                      onClick={() => setActiveTab(item.key)}
                    >
                      <Icon size={19} />
                      {isSidebarOpen && <span className="nav-text">{item.label}</span>}
                      {isSidebarOpen && item.badge != null && (
                        <span className="nav-badge">{item.badge}</span>
                      )}
                    </button>
                  );
                })}
              </div>
            );
          })}
        </nav>

        {/* <nav className="sidebar-nav">
          {hasAccess('overview') && (
          <button 
            className={`nav-item ${activeTab === 'overview' ? 'active' : ''}`}
            onClick={() => setActiveTab('overview')}
          >
            <Home size={20} />
            {isSidebarOpen && <span className="nav-text">Overview</span>}
          </button>
          )}
            {hasAccess('members') && (
          <button 
            className={`nav-item ${activeTab === 'members' ? 'active' : ''}`}
            onClick={() => setActiveTab('members')}
          >
            <Users size={20} />
            {isSidebarOpen && <span className="nav-text">Members</span>}
          </button>
            )}

        {(
  hasAccess('tasks') ||
  hasAccess('dealers') ||
  hasAccess('contacts') ||
  hasAccess('bookings') ||
  hasAccess('priceforms')
) && (
<div className="nav-item-group">
  <button
    className={`nav-item ${
      ['tasks', 'dealers', 'contacts', 'bookings', 'priceforms'].includes(activeTab)
        ? 'active'
        : ''
    }`}
    onClick={() => setFormsOpen(!formsOpen)}
  >
    <BookCheck size={20} />
    {isSidebarOpen && (
      <>
        <span className="nav-text">Forms</span>
        <ChevronDown
          size={16}
          className={`chevron ${formsOpen ? 'open' : ''}`}
        />
      </>
    )}
  </button>

  {formsOpen && isSidebarOpen && (
    <div className="submenu">
      {hasAccess('tasks') && (
      <button
        className={`submenu-item ${activeTab === 'tasks' ? 'active' : ''}`}
        onClick={() => setActiveTab('tasks')}
      >
        <span className="bullet">◦</span>
        <span>Test Ride Bookings</span>
      </button>
      )}

    {hasAccess('dealers') && (
      <button
        className={`submenu-item ${activeTab === 'dealers' ? 'active' : ''}`}
        onClick={() => setActiveTab('dealers')}
      >
        <span className="bullet">◦</span>
        <span>Dealer Forms</span>
      </button>
    )}

   {hasAccess('contacts') && (
      <button
        className={`submenu-item ${activeTab === 'contacts' ? 'active' : ''}`}
        onClick={() => setActiveTab('contacts')}
      >
        <span className="bullet">◦</span>
        <span>Contact Forms</span>
      </button>
   )}

   {hasAccess('bookings') && (
      <button
        className={`submenu-item ${activeTab === 'bookings' ? 'active' : ''}`}
        onClick={() => setActiveTab('bookings')}
      >
        <span className="bullet">◦</span>
        <span>Bookings</span>
      </button>
   )}


    </div>
  )}
</div>
)}

           {hasAccess('careers') && (
          <button 
            className={`nav-item ${activeTab === 'careers' ? 'active' : ''}`}
            onClick={() => setActiveTab('careers')}
          >
            <IdCardLanyard size={20} />
            {isSidebarOpen && <span className="nav-text">Career Postings</span>}
          </button>
           )}
             {hasAccess('applications') && (
          <button 
            className={`nav-item ${activeTab === 'applications' ? 'active' : ''}`}
            onClick={() => setActiveTab('applications')}
          >
            <Users2 size={20} />
            {isSidebarOpen && <span className="nav-text">Applications</span>}
          </button>
             )}
          
          {hasAccess('payments') && (
          <button 
            className={`nav-item ${activeTab === 'payments' ? 'active' : ''}`}
            onClick={() => setActiveTab('payments')}
          >
            <CreditCard size={20} />
            {isSidebarOpen && <span className="nav-text">Payments</span>}
          </button>
          )}

            {hasAccess('apiaccess') && (
          <button 
            className={`nav-item ${activeTab === 'apiaccess' ? 'active' : ''}`}
            onClick={() => setActiveTab('apiaccess')}
          >
            <KeyRound size={20} />
            {isSidebarOpen && <span className="nav-text">API Keys</span>}
          </button>
          )}

            {hasAccess('pageeditor') && (
           <button 
            className={`nav-item ${activeTab === 'pageeditor' ? 'active' : ''}`}
            onClick={() => setActiveTab('pageeditor')}
          >
            <FileTypeIcon size={20} />
            {isSidebarOpen && <span className="nav-text">Pages Editor</span>}
          </button>
            )}
              {hasAccess('auditlogs') && (
          <button 
            className={`nav-item ${activeTab === 'auditlogs' ? 'active' : ''}`}
            onClick={() => setActiveTab('auditlogs')}
          >
            <FileUser size={20} />
            {isSidebarOpen && <span className="nav-text">Audit Logs</span>}
          </button>
              )}
                {hasAccess('seoschema') && (
          <button 
            className={`nav-item ${activeTab === 'seoschema' ? 'active' : ''}`}
            onClick={() => setActiveTab('seoschema')}
          >
            <Package size={20} />
            {isSidebarOpen && <span className="nav-text">SEO Schema</span>}
          </button>
                )}


          {hasAccess('blogs') && (
          <button 
            className={`nav-item ${activeTab === 'blogs' ? 'active' : ''}`}
            onClick={() => setActiveTab('blogs')}
          >
            <List size={20} />
            {isSidebarOpen && <span className="nav-text">Blogs</span>}
          </button>
                )}
               
          {hasAccess('vehicles') && (
          <button 
            className={`nav-item ${activeTab === 'vehicles' ? 'active' : ''}`}
            onClick={() => setActiveTab('vehicles')}
          >
            <Bike size={20} />
            {isSidebarOpen && <span className="nav-text">Vehicles</span>}
          </button>
          )}

          
  {hasAccess('banks') && (
          <button 
            className={`nav-item ${activeTab === 'banks' ? 'active' : ''}`}
            onClick={() => setActiveTab('banks')}
          >
            <Landmark size={20} />
            {isSidebarOpen && <span className="nav-text">Banks</span>}
          </button>
          )}

            {hasAccess('sectionmanager') && (
          <button 
            className={`nav-item ${activeTab === 'sectionmanager' ? 'active' : ''}`}
            onClick={() => setActiveTab('sectionmanager')}
          >
            <PersonStanding size={20} />
            {isSidebarOpen && <span className="nav-text">Section Visibility</span>}
          </button>
            )}
            {hasAccess('cities') && (
  <button 
    className={`nav-item ${activeTab === 'cities' ? 'active' : ''}`}
    onClick={() => setActiveTab('cities')}
  >
    <MapPinned size={20} />
    {isSidebarOpen && <span className="nav-text">Cities and States</span>}
  </button>
)}

{hasAccess('dealerslist') && (
  <button 
    className={`nav-item ${activeTab === 'dealerslist' ? 'active' : ''}`}
    onClick={() => setActiveTab('dealerslist')}
  >
    <Building2 size={20} />
    {isSidebarOpen && <span className="nav-text">Dealers List</span>}
  </button>
)}
        </nav> */}

        <div className="sidebar-footer">
          <div className="admin-profile">
            <div className="admin-avatar">{adminData?.avatar}</div>
            {isSidebarOpen && (
              <div className="admin-info">
                <p className="admin-name">{adminData?.name}</p>
               
              </div>
            )}
           
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className={`main-content ${isSidebarOpen ? '' : 'expanded'}`}>
        <header className="top-bar">
          <div className="topbar-left">
            <button className="menu-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
              <Menu size={24} />
            </button>
            <div className="search-bar">
              <Search size={18} className="search-icon" />
              <input type="text" placeholder="Search anything..." />
            </div>
          </div>
          <div className="top-bar-actions">
            <button className="icon-btn"
            onClick={() =>
            setOpenNotifications(!openNotifications)
        }
            >
              <Bell size={20} />
              <NotificationBell 
               open={openNotifications}
        notifications={notifications}
        onClick={(item) => {

            console.log(item);

        }}
              />
              {/* <span className="notification-badge">3</span> */}
            </button>
            <button className="icon-btn">
              <Settings size={20} />
            </button>
            <div className="user-menu-container">
              <button className="user-menu" onClick={() => setShowUserMenu(!showUserMenu)}>
                <div className="user-avatar">{adminData?.avatar}</div>
                {showUserMenu && (
                  <div className="user-dropdown">
                    <div className="dropdown-header">
                      <p className="dropdown-name">{adminData?.name}</p>
                      <p className="dropdown-email">{adminData?.email}</p>
                    </div>
                    <div className="dropdown-divider"></div>
                    <button className="dropdown-item" onClick={() => setProfileOpen(true)}>
                      <User size={16} />
                      Profile
                    </button>
                    <button className="dropdown-item">
                      <Settings size={16} />
                      Settings
                    </button>
                    <div className="dropdown-divider"></div>
                    <button className="dropdown-item danger" onClick={() => navigate('/')}>
                      <LogOut size={16} />
                      Logout
                    </button>
                  </div>
                )}

               {profileopen && (
                // <Modal />
  <div className="modal-overlay" onClick={() => setProfileOpen(false)}>
    <div className="profilemodel-container" onClick={(e) => e.stopPropagation()}>
      <div className="namecontainer">
        <h1>{adminData.name}</h1>
      </div>
      <div className="emailcontainer">
        <h1>{adminData.email}</h1>
      </div>
    
      <button className="modalclose-btn" onClick={() => setProfileOpen(false)}>Close</button>
    </div>
  </div>
)}
               
              </button>
              
            </div>
          </div>
        </header>
        <div className="content-area">
          {renderContent()}
        </div>
      </main>   
    </div>
  );
};

export default Dashboard;